import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useLocation } from "react-router-dom";
import { Form, FormGroup, Label, Row, Col, Alert } from "reactstrap";
import { post } from "axios";

import { API_BASE_URL } from "../../../../_services/constant";
import { postMethod } from "../../../../_services/_postMethod";
import Loader from "../../../modules/loader";

function useQuery() {
  return new URLSearchParams(useLocation().search);
}

const AddCustomerReview = (props) => {
  const queryParams = useQuery();
  const id = queryParams.get("id") === "" ? null : queryParams.get("id");
  const { register, handleSubmit } = useForm();

  const [load, setLoad] = useState(false);
  const [loadInser, setLoadInsert] = useState(false);
  const [loadDelete, setLoadDelete] = useState(false);
  const [loadDeleteMsg, setLoadDeleteMsg] = useState("Deleted");
  const [param, setParam] = useState({
    tran_id: "0",
    review: "",
    image_path: "",
    customer_name: "",
    branch_id: "",
  });
  const [paramImageShow, setParamImageShow] = useState("");
  const [paramImageShowRequired, setParamImageShowRequired] = useState(false);
  const [selectedImageFile, setSelectedImageFile] = useState(null);
  const [selectedImageName, setSelectedImageName] = useState("");
  const [success, setSuccess] = useState(false);
  const [successDelete, setSuccessDelete] = useState(false);

  function createGuid() {
    return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (c) {
      const r = (Math.random() * 16) | 0;
      const v = c === "x" ? r : (r & 0x3) | 0x8;
      return v.toString(16);
    });
  }

  const imagePreviewSrc = paramImageShow
    ? paramImageShow.indexOf("data:") === 0
      ? paramImageShow
      : API_BASE_URL + "customerreviewimage/" + paramImageShow
    : "";

  const handleImageChange = (fileList) => {
    const file = fileList && fileList[0];

    if (!file) {
      return;
    }

    const reader = new FileReader();
    reader.onload = function (event) {
      setParamImageShow(event.target.result);
      setSelectedImageFile(file);
      setSelectedImageName(file.name);
      setParamImageShowRequired(false);
    };
    reader.readAsDataURL(file);
  };

  const removeImage = () => {
    const fileInput = document.getElementById("updateImage");

    if (fileInput) {
      fileInput.value = "";
    }

    setParam({ ...param, image_path: "" });
    setParamImageShow("");
    setSelectedImageFile(null);
    setSelectedImageName("");
    setParamImageShowRequired(false);
  };

  const insertData = (values) => {
    const fileInput = document.getElementById("updateImage");
    const inputFile = fileInput && fileInput.files ? fileInput.files[0] : null;
    const reviewImage = selectedImageFile || inputFile;
    const formData = new FormData();
    const nextParam = { ...param };

    if (reviewImage) {
      const fileName = "image-" + createGuid();
      const extension = reviewImage.name.substring(reviewImage.name.lastIndexOf("."));
      const imagePath = fileName + extension;

      values.image_path = imagePath;
      nextParam.image_path = imagePath;
      formData.append("files", reviewImage, fileName);
    }

    if (nextParam.image_path === "" && !reviewImage) {
      setParamImageShowRequired(true);
      return;
    }

    setLoadInsert(true);
    postMethod("api/masters/customer/customerreview/insert", nextParam).then((data) => {
      if (data.data[0].valid) {
        if (reviewImage) {
          uploadImageFunc(formData);
        } else {
          setSuccess(true);
          setTimeout(() => {
            props.history.push("/branch/customer-review");
          }, 2000);
        }
      } else {
        setLoadInsert(false);
      }
    });
  };

  const uploadImageFunc = (formData) => {
    const url = API_BASE_URL + "api/masters/customer/UploadCustomerReviewImage";
    const config = {
      headers: {
        "content-type": "multipart/form-data",
        "auth-token": localStorage.getItem("jwl_token"),
      },
    };

    post(url, formData, config).then(
      () => {
        setSuccess(true);
        setTimeout(() => {
          props.history.push("/branch/customer-review");
        }, 2000);
      },
      () => {
        setLoadInsert(false);
        setSuccess(false);
      }
    );
  };

  const handleDelete = () => {
    const proceed = window.confirm("Do you Really Wish to Delete this Entry..?!");

    if (proceed) {
      setLoadDelete(true);
      postMethod("api/masters/customer/customerreview/delete", {
        tran_id: param.tran_id,
      }).then((data) => {
        if (data.data[0].valid) {
          setSuccessDelete(true);
          setTimeout(() => {
            props.history.push("/branch/customer-review");
          }, 2000);
        } else {
          setSuccessDelete(true);
          setTimeout(() => {
            setSuccessDelete(false);
          }, 4000);
          setLoadDeleteMsg(data.error);
          setLoadDelete(false);
        }
      });
    }
  };

  useEffect(() => {
    if (id !== null) {
      setLoad(true);
      const temp = window.atob(id);
      postMethod("api/masters/customer/customerreview/preview", { tran_id: temp }).then((dataD) => {
        const data = dataD.data;
        setParam({
          ...param,
          tran_id: data.tran_id,
          review: data.review,
          image_path: data.image_path,
          customer_name: data.customer_name,
        });
        setParamImageShow(data.image_path);
        setSelectedImageName(data.image_path);
        setLoad(false);
      });
    }
  }, []);

  return (
    <>
      {load ? <Loader /> : null}
      <Form onSubmit={handleSubmit(insertData)} className="review-editor-form">
        <input
          type="hidden"
          name="tran_id"
          value={id == null ? "0" : param.tran_id}
          ref={register}
        />
        <div className="card shadow review-editor-card">
          <div className="review-editor-header">
            <div className="review-editor-title">
              <span className="review-editor-icon">
                <i className="fa fa-star"></i>
              </span>
              <div>
                <h3>{id ? "Edit Customer Review" : "Add Customer Review"}</h3>
                <p>Capture a customer testimonial and the image shown with it.</p>
              </div>
            </div>
          </div>

          <div className="card-body review-editor-body">
            <Row>
              <Col lg={7} md={12}>
                <div className="review-editor-section">
                  <FormGroup className="review-editor-field">
                    <Label>
                      Customer Name <span>*</span>
                    </Label>
                    <input
                      type="text"
                      required
                      value={param.customer_name}
                      className="form-control review-editor-input"
                      name="customer_name"
                      placeholder="Enter customer name"
                      onChange={(e) =>
                        setParam({ ...param, customer_name: e.target.value })
                      }
                      ref={register}
                    />
                  </FormGroup>

                  <FormGroup className="review-editor-field mb-0">
                    <Label>
                      Review <span>*</span>
                    </Label>
                    <div className="review-editor-textarea-wrap">
                      <textarea
                        required
                        maxLength="500"
                        value={param.review}
                        className="form-control review-editor-textarea"
                        name="review"
                        placeholder="Write customer review here..."
                        onChange={(e) => setParam({ ...param, review: e.target.value })}
                        ref={register}
                      ></textarea>
                      <small>{param.review.length} / 500</small>
                    </div>
                  </FormGroup>
                </div>
              </Col>

              <Col lg={5} md={12}>
                <div className="review-editor-section review-editor-image-section">
                  <FormGroup className="review-editor-field mb-0">
                    <Label>
                      Customer Image <span>*</span>
                    </Label>
                    <div className="review-editor-upload">
                      {imagePreviewSrc ? (
                        <div className="review-editor-preview">
                          <img src={imagePreviewSrc} alt="Customer review" />
                          <button type="button" onClick={removeImage}>
                            <i className="fa fa-trash"></i>
                          </button>
                        </div>
                      ) : (
                        <div className="review-editor-empty-preview">
                          <i className="fa fa-image"></i>
                          <p>No image selected</p>
                        </div>
                      )}

                      <label className="review-editor-upload-control">
                        <input
                          id="updateImage"
                          type="file"
                          multiple={false}
                          accept="image/*"
                          name="Choose Image"
                          onChange={(e) => handleImageChange(e.target.files)}
                        />
                        <i className="fa fa-cloud-upload"></i>
                        <strong>Choose Image</strong>
                        <small>{selectedImageName || "JPG, PNG"}</small>
                      </label>
                    </div>
                    {paramImageShowRequired ? (
                      <span className="form-text text-danger">Customer image is required</span>
                    ) : null}
                  </FormGroup>
                </div>
              </Col>
            </Row>

            {success ? <Alert color="success">Saved Successfully</Alert> : null}
            {successDelete ? <Alert color="danger">{loadDeleteMsg}</Alert> : null}
          </div>

          <div className="review-editor-footer">
            <a href="/branch/customer-review" className="btn review-editor-cancel-btn">
              Cancel
            </a>
            {id &&
              (loadDelete ? (
                <button type="button" className="btn btn-danger review-editor-action-btn">
                  Deleting..
                </button>
              ) : (
                <button
                  type="button"
                  onClick={handleDelete}
                  className="btn btn-danger review-editor-action-btn"
                >
                  Delete
                </button>
              ))}

            {loadInser ? (
              <button type="button" className="btn btn-primary review-editor-action-btn">
                Saving..
              </button>
            ) : (
              <button type="submit" className="btn btn-primary review-editor-action-btn">
                Save Review
              </button>
            )}
          </div>
        </div>
      </Form>
    </>
  );
};

export default AddCustomerReview;
